import { render, staticRenderFns } from "./FilterChipsContext.vue?vue&type=template&id=0996bd0d"
import script from "./FilterChipsContext.vue?vue&type=script&lang=js"
export * from "./FilterChipsContext.vue?vue&type=script&lang=js"
import style0 from "./FilterChipsContext.vue?vue&type=style&index=0&id=0996bd0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports